import React from "react";
import styles from "./PaymentMethod.module.scss";
import api from "../../../../services/Api";
import axios from "axios";
import md5 from "md5/md5";
import Button from "@material-ui/core/Button";
import { ReactComponent as TpayLogo } from "./../../../../assets/svg/tpay_logo_blue.svg";
import User from "../../../../services/User";
import { Alert } from "@material-ui/lab";
import classNames from "classnames";
import Cookies from "src/helpers/Cookies";

class PaymentMethod extends React.Component<any, any> {
  constructor(props) {
    super(props);

    const id = process.env.REACT_APP_TPAY_MERCHANT_ID;
    const price = Number(this.props.price).toFixed(2);
    //parseFloat(Math.round(Number(this.props.price) * 100) / 100).toFixed(2);
    const crc = new Date().getTime();
    const apiPassword = process.env.REACT_APP_TPAY_API_PASSWORD;
    const apiKey = process.env.REACT_APP_TPAY_API_KEY;
    const returnUrl = process.env.REACT_APP_TPAY_RETURN_URL;
    const returnErrorUrl = process.env.REACT_APP_TPAY_RETURN_ERROR_URL;
    const secureCode = process.env.REACT_APP_TPAY_SECURE_CODE;

    this.state = {
      clientId: this.props.clientId,
      paymentURL: null,
      appointmentId: null,
      crc: crc,
      md5: md5(`${id}${price}${crc}${secureCode}`),
      price: price,
      title: null,
      online: null,
      accountId: id,
      allOk: false,
      error: null,
      apiPassword: apiPassword,
      apiKey: apiKey,
      returnUrl: returnUrl,
      secureCode: secureCode,
      returnErrorUrl: returnErrorUrl,
      paymentMethods: null,
      selectedPaymentMethod: null,
    };
  }

  componentDidMount() {
    if (this.state.clientId) {
      this.createAppointment();
    } else {
      this.createClient();
    }
    this.getPaymentMethods();
  }

  createClient = () => {
    let recommendationNumber = Cookies.getCookie("refCode");

    recommendationNumber =
      recommendationNumber != "" ? recommendationNumber : undefined;

    api
      .post("clients", {
        name: this.props.name,
        surname: this.props.surname,
        recommendationNumber,
      })
      .then((response) => {
        if (response.data.success === true) {
          this.setState({
            clientId: response.data.data.id,
          });
          this.props.setClinetId(response.data.data.id);
          this.createAppointment();
        }
      });
  };

  createAppointment = (userCreated) => {
    if (User.getUser() || userCreated) {
      api
        .post("/appointments", {
          start: this.props.time.start,
          end: this.props.time.end,
          topic: this.props.topic,
          comments: this.props.comments,
          lawyerId: this.props.lawyerId,
          clientId: this.state.clientId,
          domainId: this.props.domain,
          file: this.props.files,
        })
        .then((response) => {
          if (response.data.success === true) {
            this.setState({
              appointmentId: response.data.data.id,
            });

            if (userCreated) {
              this.createPaymentUrl();
            }
          }
        })
        .catch((error) => {
          this.setState({
            error: error.response.data.error,
          });
        });
    }
  };

  createPaymentUrl = () => {
    let self = this;

    api
      .post("/payments/tPay", {
        appointmentId: this.state.appointmentId,
        amount: this.state.price,
        group: this.state.selectedPaymentMethod,
      })
      .then((response) => {
        if (response.status === 200 && response.data.success === true) {
          if (User.getUser()) {
            window.location.href = response.data.data.paymentURL;
          } else {
            this.props.changeStep("next");
          }
        }
      })
      .catch((error) => {
        this.setState({
          error:
            "Wystąpił problem podczas tworzenia płatności. Zgłoś to administratorowi.",
        });
      });
  };

  getPaymentMethods = () => {
    let self = this;

    api
      .get("/payments/tPay/paymentMethods")
      .then((response) => {
        if (response.status === 200) {
          self.setState({
            paymentMethods: response.data.data,
          });
        }
      })
      .catch((error) => {
        self.setState({
          error:
            "Wystąpił problem podczas tworzenia płatności. Zgłoś to administratorowi.",
        });
      });
  };

  postPayment = () => {
    const md5sum = md5(
      `${this.state.accountId}${this.state.title}${Number(
        this.state.price
      ).toFixed(2)}${this.state.crc}${this.state.secureCode}`
    );

    api
      .post("payments", {
        appointmentId: this.state.appointmentId,
        title: this.state.title,
        amount: this.state.price,
        accountNumber: this.state.accountId,
        online: this.state.online,
        url: this.state.paymentURL,
        crc: this.state.crc,
        md5: md5sum,
        isTest: false,
        // status: "string",
        // error: "string"
      })
      .then((response) => {
        if (response.data.success === true) {
          this.setState({
            allOk: true,
          });
        }
      })
      .catch((error) => {
        this.setState({
          error: error.response.data.error,
        });
      });
  };

  submitForm = () => {
    if (User.getUser()) {
      this.createPaymentUrl();
    } else {
      this.props.changeStep("next");
    }
  };

  selectPaymentMethod = (id) => {
    this.setState({
      selectedPaymentMethod: id,
      allOk: true,
    });
  };

  render() {
    const { price, error, paymentMethods } = this.state;

    if (!this.props.show) return null;
    else
      return (
        <div className={styles.PaymentMethod}>
          <div className={styles.summary}>Podsumowanie</div>
          <div className={styles.introduction}>
            <div className={styles.price}>{price} zł</div>
            <div className={styles.desc}>
              wideokonsultacja online (koszt za 30 minut konsultacji)
            </div>
          </div>

          {error && (
            <>
              <Alert severity="error">{error}</Alert>
              <br />
            </>
          )}
          <div className={styles.summary}>Wybierz metodę płatności</div>
          {paymentMethods && (
            <>
              <div>
                {Object.keys(paymentMethods).map((method, key) => {
                  return (
                    <img
                      className={classNames({
                        payment_to_choose: true,
                        selected:
                          this.state.selectedPaymentMethod ==
                          paymentMethods[method].id,
                      })}
                      src={paymentMethods[method].img}
                      onClick={() =>
                        this.selectPaymentMethod(paymentMethods[method].id)
                      }
                    ></img>
                  );
                })}
              </div>
            </>
          )}

          <div className={styles.graySection}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<TpayLogo height="18px" />}
              onClick={this.submitForm}
              disabled={!this.state.allOk && User.getUser()}
            >
              Potwierdź płatność
            </Button>
          </div>
        </div>
      );
  }
}

PaymentMethod.defaultProps = {};

export default PaymentMethod;
